package com.far.suller.components

import androidx.compose.runtime.*
import com.far.suller.models.Testimonial
import com.far.suller.util.Constants
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

private val AMBER_500 = Color.rgb(245, 158, 11)
private val DARK_CARD_BG = Color.rgb(22, 18, 15)

@Composable
fun TestimonialCardV2(
    modifier: Modifier = Modifier,
    testimonial: Testimonial,
    breakpoint: Breakpoint,
) {
    var isHovered by remember { mutableStateOf(false) }

    Box(
        modifier = modifier
            .width(if (breakpoint >= Breakpoint.MD) 450.px else 320.px)
            .minWidth(if (breakpoint >= Breakpoint.MD) 450.px else 320.px)
            .padding(all = 32.px)
            .backgroundColor(DARK_CARD_BG)
            .borderRadius(24.px)
            .border(1.px, LineStyle.Solid, if (isHovered) AMBER_500 else Color.rgba(255, 255, 255, 0.05f))
            .onMouseEnter { isHovered = true }
            .onMouseLeave { isHovered = false }
            .styleModifier {
                property("flex-shrink", "0")
                property("transition", "all 0.3s ease")
                if (isHovered) {
                    property("transform", "translateY(-10.px)")
                    property("box-shadow", "0 20px 40px rgba(245, 158, 11, 0.1)")
                } else {
                    property("box-shadow", "0 10px 30px rgba(0,0,0,0.2)")
                }
            },
    ) {
        Column {
            Row(
                modifier = Modifier.margin(bottom = 24.px),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                // Avatar with premium border
                Box(
                    modifier = Modifier
                        .size(if (breakpoint >= Breakpoint.MD) 70.px else 50.px)
                        .margin(right = 20.px)
                        .borderRadius(50.percent)
                        .border(2.px, LineStyle.Solid, AMBER_500)
                        .padding(all = 3.px)
                        .overflow(Overflow.Hidden),
                ) {
                    Image(
                        modifier = Modifier.fillMaxSize().objectFit(ObjectFit.Cover).borderRadius(50.percent),
                        src = testimonial.image,
                    )
                }

                Column {
                    P(
                        attrs = Modifier
                            .margin(topBottom = 0.px)
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontSize(18.px)
                            .fontWeight(FontWeight.Bold)
                            .color(Colors.White)
                            .toAttrs(),
                    ) {
                        Text(testimonial.fullName)
                    }

                    P(
                        attrs = Modifier
                            .margin(topBottom = 0.px)
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontSize(13.px)
                            .fontWeight(FontWeight.Medium)
                            .color(AMBER_500)
                            .toAttrs(),
                    ) {
                        Text(testimonial.profession)
                    }
                }
            }

            // Quote Icon
            Span(
                attrs = Modifier
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(40.px)
                    .color(Color.rgba(245, 158, 11, 0.2f))
                    .styleModifier {
                        property("line-height", "1")
                        property("margin-bottom", "-10px")
                        property("display", "block")
                    }
                    .toAttrs(),
            ) {
                Text("“")
            }

            P(
                attrs = Modifier
                    .margin(topBottom = 0.px)
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(15.px)
                    .color(Color.rgba(255, 255, 255, 0.7f))
                    .lineHeight(1.6)
                    .styleModifier {
                        property("font-style", "italic")
                    }
                    .toAttrs(),
            ) {
                Text(testimonial.review)
            }

            // Rating stars
            Row(modifier = Modifier.margin(top = 20.px)) {
                repeat(5) {
                    Span(
                        attrs = Modifier
                            .margin(right = 4.px)
                            .fontSize(14.px)
                            .color(AMBER_500)
                            .toAttrs(),
                    ) {
                        Text("★")
                    }
                }
            }
        }
    }
}
